import UserNotFoundLockedOut from './UserNotFoundLockedOut';

export default UserNotFoundLockedOut;
